import type { ReactNode } from "react";
import styles from "./ChartOfAccountsTemplateStepSubtitle.module.scss";

interface Props {
    children: ReactNode;
}

export const ChartOfAccountsTemplateStepSubtitle = ({ children }: Props) => (
    <div className={styles.subtitleContainer}>{children}</div>
);
